import { gql } from '@apollo/client';

export const GetStudentSchoolClassesQuery = gql`
    query GetStudentSchoolClasses {
        getStudentSchoolClasses
    }
`;
